import { Helper } from '../Helper';
export class GetModuleHelper extends Helper {
    constructor(options) {
        super();
        this.moduleIndex = options.moduleIndex;
    }
    emit(sb, node, options) {
        if (options.pushValue) {
            sb.emitHelper(node, options, sb.helpers.getModules);
            sb.emitPushInt(node, this.moduleIndex);
            sb.emitOp(node, 'PICKITEM');
        }
    }
}

//# sourceMappingURL=GetModuleHelper.js.map
